import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/icons/icon-approve-white.svg'


const _hoisted_1 = ["disabled"]
const _hoisted_2 = {
  key: 1,
  class: "spiner-wr"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!$setup.showLoader)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: _normalizeClass(["button approve", { disabled: $setup.props.disabled, 'disabled-business-owner': !$setup.props.isSameBusinessOwner }]),
          onClick: _withModifiers($setup.onButtonApprove, ["stop"]),
          disabled: $setup.props.disabled || !$setup.props.isSameBusinessOwner
        }, [...(_cache[1] || (_cache[1] = [
          _createElementVNode("img", { src: _imports_0 }, null, -1),
          _createTextVNode("Approve", -1)
        ]))], 10, _hoisted_1))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[2] || (_cache[2] = [
          _createElementVNode("div", { class: "spinner spinner-small" }, null, -1)
        ]))])),
    _createVNode($setup["EOIApprovalModal"], {
      isOpen: $setup.isOpenApproveModal,
      lot: $props.lot,
      onClose: $setup.onCloseApproveModal,
      onConfirm: $setup.onConfirm,
      onLoading: $setup.onLoadingEvent
    }, null, 8, ["isOpen", "lot"]),
    _createVNode($setup["AttentionModal"], {
      isOpen: $setup.showAttentionModal,
      title: "Attention",
      description: "Payments are temporarily unavailable. Please try again later.",
      onClose: _cache[0] || (_cache[0] = ($event: any) => ($setup.showAttentionModal = false))
    }, null, 8, ["isOpen"])
  ], 64))
}